import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";

import { ProductBySlugNonNullable } from "@/common/contracts/pdp.contracts";
import { USER_ADS_ROUTE } from "@/common/static/routes.static";
import { cn } from "@/common/utils/css.utils";
import { ProductDetailsInfoSellerContact } from "@/components/ProductDetail/info/seller/ProductDetailsInfoSellerContact";
import { ProductDetailsInfoSellerDate } from "@/components/ProductDetail/info/seller/ProductDetailsInfoSellerDate";
import { ProductDetailsInfoSellerLocation } from "@/components/ProductDetail/info/seller/ProductDetailsInfoSellerLocation";
import { ProductDetailsInfoSellerReviews } from "@/components/ProductDetail/info/seller/ProductDetailsInfoSellerReviews";
import { ProductDetailsInfoSellerTitle } from "@/components/ProductDetail/info/seller/ProductDetailsInfoSellerTitle";
import { Helper } from "@/ui/typography/Helper";

type ProductDetailsInfoSellerReviewsProps = {
  product: ProductBySlugNonNullable;
  className?: string;
};

export const ProductDetailsInfoSeller = ({
  product,
  className,
}: ProductDetailsInfoSellerReviewsProps) => {
  const { t } = useTranslation();
  const router = useRouter();

  const merchant = product.merchant;
  const merchantId = merchant.id;

  return (
    <div className={cn("flex flex-col space-y-4 bg-[#FCF9F2] p-4 ", className)}>
      <div className="flex w-full flex-1 flex-col space-y-1 text-sm">
        <ProductDetailsInfoSellerTitle product={product} />
        <ProductDetailsInfoSellerReviews product={product} />
        <ProductDetailsInfoSellerLocation product={product} />
        <ProductDetailsInfoSellerDate product={product} />
      </div>
      {/* A button, not a link: /user-ads is robots-disallowed and must not be crawlable from every PDP. */}
      <button
        type="button"
        className="text-left"
        onClick={() => router.push(`${USER_ADS_ROUTE}/${merchantId}`)}
      >
        <Helper className="text-brand-500 underline">
          {t("pdp:pdp-seller-block-more-ads")}
        </Helper>
      </button>
      <ProductDetailsInfoSellerContact product={product} />
    </div>
  );
};
